import { useEffect, useState } from "react";
import { useLang } from "../../i18n/LanguageContext";
import ServiceTabs from "./ServiceTabs";
import ServicePanels from "./ServicePanels";
import { trackServiceView } from "../utils/analytics";

export default function Services() {
  const { t } = useLang();
  const [active, setActive] = useState(0);

  useEffect(() => {
    const serviceName = t.services.tabs[active] || "Service";
    trackServiceView(serviceName);
  }, [active, t.services.tabs]);

  return (
    <section id="services" className="py-32 bg-[#111112] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-4 mb-20">
          <div className="text-[#F28C18] uppercase text-xs font-black tracking-widest">{t.services.label}</div>
          <h2 className="text-3xl sm:text-5xl font-black tracking-tight text-white uppercase">{t.services.title}</h2>
          <div className="w-20 h-1 bg-[#F28C18] mx-auto rounded" />
        </div>
        <ServiceTabs active={active} onSelect={setActive} />
        <ServicePanels active={active} />
      </div>
    </section>
  );
}
